// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"1fcbceb12542cabdbc5d","873":"edf6a7068ed825e1f64e"}[chunkId] + ".js";
};